/** @format */

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBS2epinVOvykZ-6LrihOvbUJITuvMCLko",
    authDomain: "kanji-mochidemy.firebaseapp.com",
    projectId: "kanji-mochidemy",
    storageBucket: "kanji-mochidemy.appspot.com",
    messagingSenderId: "737115350813",
    appId: "1:737115350813:web:ade86b8354647f9f89e3f4",
    measurementId: "G-290P9LL236",
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const providerGoogle = new GoogleAuthProvider();

const providerApple = new OAuthProvider("apple.com");
providerApple.addScope("email");
providerApple.addScope("name");

export { auth, providerGoogle, providerApple, OAuthProvider };
